
import imgUrl from "../assets/img/test.jpg"





  

export function printBasicViolationNotice(items) {

  if (!Array.isArray(items)) return;
  const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      
      document.body.appendChild(iframe);
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);
  
      //Avoid XSS & HTML injection
      const escapeHTML = (str = "") =>
          str
            .toString()
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
      //若傳入值為 true ，則顯示 ■，否則顯示 □
      const getCheckboxSymbol = (value) => {
        return value ? "■" : "□";
      };

 
 
 
  // 建立包含所有項目的 HTML
  let htmlContent = `
    <!DOCTYPE html>
    <html lang="zh-Hant">
    <head>
      <meta charset="UTF-8">
      <title>違反風景區通知單</title>
      <style>
         body { font-family: "標楷體",Arial, sans-serif; padding: 1rem; line-height: 1.6; }
        h1 { text-align: center; font-size:22px; }
        table { width: 100%; border-collapse: collapse; margin-top: 5px; }
        td, th { border: 1px solid #000; padding: 5px; }
        .td-width-1{width:100px;}
        .right { text-align: right; margin-top: 1rem; }
        .image-container { margin-top: 1rem; width: 100%; text-align: center; }
        .text-center { text-align: center; }
        .violation-image { display: block; width: 80%; margin: 0 auto; }
        .border-bottom{ border-bottom: 2px solid #ccc; }
        ul { list-style: none; margin-top:5px; }
        .vertical-container { vertical-align: middle; }
        .m-0 { margin: 0; }
        .p-0 { padding: 0; }
        .mr-2{ margin-right:8px; }
        .vertical { writing-mode: vertical-rl; letter-spacing: 0.5rem; white-space: nowrap; margin: 0 auto; }
        .d-flex{ display:flex;}
        /* 強制換頁 */
        .page-break {
          page-break-before: always;
        }
        p { margin-bottom:0px; }
        .check-flex{
          margin:0;
        }
      </style>
    </head>
    <body>
  `;

  // 逐個 item 生成 HTML
  items.forEach((item, index) => {

    htmlContent += `
      <div class="page-break">
        <h1>違反國家風景區管理事件通知單</h1>
        <p class="right m-0 p-0">No.${escapeHTML(item.eventNumber)}</p>
        <table>
          <tr>
            <td class="td-width-1 text-center">車牌號碼</td>
            <td rowspan="2" class="vertical-container"><div class="vertical">違規舉發</div></td>
            <td class="vertical-container"><div class="vertical">時間</div></td>
            <td>${escapeHTML(item.dt)}</td>
          </tr>
          <tr>
            <td class="td-width-1 text-center">${escapeHTML(item.licensePlate)}</td>
            <td class="vertical-container"><div class="vertical">地點 </div></td>
            <td>於${escapeHTML(item.area)}風景特定區${escapeHTML(item.publicPlaceName)}禁止(汽)機車進入之自然景觀保護區內騎乘進入並停放(汽)機車</td>
          </tr>
        </table>
      <div class="border-bottom">
          <p>貴車主您好：</p>
          <p> 一、您停車不當已違反下列規定：</p>
          <ul>
            <li>${getCheckboxSymbol(item.checkgroup1.checkbox1)} 在禁止汽機車進入之地區，違規進入並停車者。</li>
            <li>${getCheckboxSymbol(item.checkgroup1.checkbox2)}  在殘障通道或行人通道區，違規停車者。</li>
            <li>${getCheckboxSymbol(item.checkgroup1.checkbox3)}  不依車輛種類違規停車或顯有妨礙他車通行者。</li>
          </ul>
          <div class="d-flex">
            <p class="m-0"> 二、</p>
            <p class="m-0">您已違反發展觀光條例第64條第1款規定，本處己錄案並開立違規事件通知單予台端：</p> 
          </div>
      
          <ul>
            
            <li class="d-flex check-flex"><p class="m-0 mr-2">${getCheckboxSymbol(item.checkgroup2.checkbox1)} </p>
             <p class="m-0">
                若再次於禁止進入之地區停車，得由目的事業主管機關處新臺幣五千元以上十萬元以下罰鍰。
             </p>
             </li>
            <li class="d-flex"><p class="m-0 mr-2">${getCheckboxSymbol(item.checkgroup2.checkbox2)} </p>
              <p class="m-0">
                依發展觀光條例第65條規定：所處之罰鍰，經通知限期繳納，屆期未繳納者，將依法移送強制執行。
              </p>
              </li>
          </ul>
          <div class="d-flex">
            <p class="m-0" >三、</p>
            <p class="m-0" >為了維護旅遊秩序與安全，盼望您能隨時遵守管理機關公告禁止破壞生態、污染環境及危害安全之行為。</p> 
          </div>
          <p class="right">交通部觀光署東部海岸國家風景區管理處</p>
        </div>
        <div class="image-container">
          <img src="${ item.imgData|| ''}" class="violation-image" alt="違規照片" />
        </div>
      </div>
    `;
  });

  htmlContent += `</body></html>`;

  // 建立 iframe 並載入這個 HTML
  // const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.srcdoc = htmlContent;
  document.body.appendChild(iframe);

  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 200);
  };
}


export function printOfficialViolationNotice(items){
  console.log("items", items);
  console.log("Array.isArray(items)", Array.isArray(items));
  // if (!Array.isArray(items)) return;
  const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      
      document.body.appendChild(iframe);
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);
  
      //Avoid XSS & HTML injection
      const escapeHTML = (str = "") =>
          str
            .toString()
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
      //若傳入值為 true ，則顯示 ■，否則顯示 □
      const getCheckboxSymbol = (value) => {
        return value ? "■" : "□";
      };
  // 建立包含所有項目的 HTML
  let htmlContent = `
  <!DOCTYPE html>
<html lang="zh-Hant">
<head>
  <meta charset="UTF-8">
  <title>違反國家風景區事件通知單</title>
  <style>
    body {
      font-family: "標楷體", serif;
      padding: 20px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #000;
      font-size: 16px;
    }
    td, th {
      border: 1px solid #000;
      padding: 4px;
      vertical-align: middle;
      text-align: justify;
      text-justify: inter-ideograph; 

    }
    .text-left{
      text-align: left;
    }
    .text-justify{
       text-align: justify ;
       }
    .text-center{
      text-align: center;
      }

    .title {
      font-size: 23px;
      font-weight: bold;
      text-align: center;
      padding: 10px 0;
    }
    .title-2 {
      // font-weight: bold;
      // background: #f0f0f0;
      width:100px;
      text-align: center;
    }

    .title-3{
      width:100px;

    }
    .title-4{
      width: 40px;
    }

    .title-5{
      width:200px;
    }
    
    .note {
      font-size: 12px;
    }

    .f-10{
     font-size:12px;
    }

   .article {
      display: flex;
      font-size:12px;
    }
    .article-title-1 {
      min-width:40px;
      margin-bottom: 5px;
    }

    .article-title-2 {
      min-width:50px;
      margin-bottom: 5px;
    }

    .article-content {
      margin-bottom: 5px;
    }
    .page-break {
          page-break-before: always;
        }

    .d-flex{
      display:flex;
    }

    .text-right{
      text-align: right;
    }
    
    .mb-2{
      margin-bottom: 5px;
    }
    .mt-2{
     margin-top: 10px;
      }

    .mr-2{ margin-right:8px; }
  
  </style>
</head>
<body>
  `;

  // console.log("htmlContent", htmlContent);  

  // 逐個 item 生成 HTML
  items.forEach((item, index) => {
    htmlContent += `
    <div class="page-break">
    <div class="title">交通部觀光署東部海岸國家風景區管理處<br>取締違反國家風景區管理事件通知單</div>

    <div class="text-center mb-2">中華民國${escapeHTML(item.issueYear)}年${escapeHTML(item.issueMonth)}月${escapeHTML(item.issueDay)}日${escapeHTML(item.issueUnit)}字第${escapeHTML(item.issueNumber)}號</div>
    <table>

      <tr >
        <td  rowspan="5"  class="title-2">被通知人</td>
      </tr>
      <tr class="text-justify">
          <td class="title-5">
            <div class="title-5 text-justify">姓名<br></div>（法人或非法人團體名稱）</td>
          <td colspan="3">${escapeHTML(item.name)}</td>
          <td class="title-3">性別</td>
          <td colspan="3">${escapeHTML(item.gender)}</td>
      </tr>
      <tr>
          <td class="title-5">管理人或代表人之姓名</td>
          <td colspan="3">${escapeHTML(item.name)}</td>
          <td class="title-3">出生日期</td>
          <td colspan="3">${escapeHTML(item.birthday)}</td>
      </tr>
      <tr>
          <td class="title-3">身分證統一編號</td>
          <td colspan="9">${escapeHTML(item.nationalId)}</td>
      </tr>
      <tr>
        <td  class="title-5">住（居）所<br>事務所或營業所</td>
        <td  colspan="9">${escapeHTML(item.address)}</td>
      </tr>
    </table>
    <table style="margin-top:-1px;">
      <tr>
        <td  class="title-2">違反事實</td>
        <td  colspan="10">${escapeHTML(item.violationDescription)}</td>
      </tr>
      <tr>
        <td class="title-2">違反時間</td>
        <td class="title-5 text-right">中華民國${escapeHTML(item.violationYear)}年${escapeHTML(item.violationMonth)}月${escapeHTML(item.violationDay)}日${escapeHTML(item.violationHour)}時${escapeHTML(item.violationMinute)}分</td>
        <td class="title-2">違反地點</td>
        <td >${escapeHTML(item.violationPlace)}</td>
      </tr>
      <tr>
        <td class="title-2" >
          涉嫌違反法令
        </td>
        <td colspan="10" class="text-left">
           發展觀光條例 第  ${escapeHTML(item.tourismLaw.articles)}  條第  ${escapeHTML(item.tourismLaw.paragraph)}  項。<br>
           風景特定區管理規則 第  ${escapeHTML(item.scenicRule.articles)}  條第  ${escapeHTML(item.scenicRule.paragraph)}  項。<br>
           水域遊憩活動管理辦法 第  ${escapeHTML(item.waterActivityLaw.articles)}  條第  ${escapeHTML(item.waterActivityLaw.paragraph)}  項。
        </td>
      </tr>

      <tr>
        <td class="title-2" >被通知人應依下列事項辦理</td>
        <td colspan="10" class="text-left">
          <div class="d-flex">
            <div> 一、
            </div>
            <div>
              ${getCheckboxSymbol(item.stop.main)} 立即停止（${getCheckboxSymbol(item.stop.stopBehavior)}行為 ${getCheckboxSymbol(item.stop.stopConstruction)}工程 ${getCheckboxSymbol(item.stop.stopBusiness)}營業）<br>
              ${getCheckboxSymbol(item.clean.main)} 在  ${escapeHTML(item.clean.day)}  日內清理完成，  ${getCheckboxSymbol(item.restore.main)} 在  ${escapeHTML(item.restore.day)}  日內恢復原狀，${getCheckboxSymbol(item.other.main)}其他：${escapeHTML(item.other.description)}
            </div>
          </div>
         
        
          <div class="d-flex">
            <div> 二、
            </div>
            <div>台端涉及違反「發展觀光條例」規定事項，特此通知：<br>
            ${getCheckboxSymbol(item.rule1)} 依前項辦理逾期，即依法處分。<br>
            ${getCheckboxSymbol(item.rule2.main)}  並依發展觀光條例第   ${escapeHTML(item.rule2.articles)}   條第   ${escapeHTML(item.rule2.section)}   項處分，處分書另寄。
            </div>
          </div>
          
        </td>
      </tr>

      <tr>
        <td class="title-2" >通知送達方式</td>

        <td colspan="10" class="text-left">
           ${getCheckboxSymbol(item.delivery.registered)} 雙掛號寄出　　${getCheckboxSymbol(item.delivery.signIn)}親送簽收：
        </td>
      </tr>

      <tr>
        <td class="title-2" >附註</td>
        <td  class="note text-left" colspan="10">
      <div class="article">
        <div class="article-title-1">一、</div>
        <div class="article-content ">接到本通知單當日起10日內得向本處提出陳述意見書，如逾期未提出者，依行政程序法第105條第3項規定，視為放棄陳述意見機會。</div>
      </div>
      <div class="article">
        <div class="article-title-1">二、</div>
        <div class="article-content ">「發展觀光條例」有關處分規定如下：</div>
      </div>
        <div class="article">
          <div class="article-title-2">第60條：</div>
          <div class="article-content ">
          (第一項)於公告禁止區域從事水域遊憩活動或不遵守水域遊憩活動管理機關對有關水域遊憩活動所為種類、範圍、時間及行為之限制命令，由其水域遊憩活動管理機關處新臺幣一萬元以上五萬元以下罰鍰，並禁止其活動。(第二項)前項行為具營利性質者，處新臺幣五萬元以上二十萬元以下罰鍰，並禁止其活動。(第三項)具營利性質者未依主管機關所定保險金額、投保責任保險者，處新臺幣三萬元以上十五萬元以下罰鍰，並禁止其活動。
          </div>
        </div>

        <div class="article">
          <div class="article-title-2">第62條：</div>
          <div class="article-content">
          (第一項)損壞觀光地區或風景特定區之名勝、自然資源或觀光設施者，有關目的事業主管機關得處行為人新臺幣五千元以下罰鍰，並責令回復原狀或回復環境。其無法回復原狀者，有關目的事業主管機關得再處行為人新臺幣五萬元以下罰鍰。(第二項)於該營造自然人文生態景觀區依規定申請導覽等專業導覽人員陪同進入者，有關目的事業主管機關得處行為人新臺幣三萬元以下罰鍰。
          </div>
        </div>

        <div class="article">
          <div class="article-title-2">第63條：</div>
          <div class="article-content">
          (第一項)於風景特定區或觀光地區內堆置營區或流動攤販，擅自設置指示標誌或廣告物、強行向旅客拍照並收取費用、強行向旅客推銷物品或有其他擾亂旅客安寧之行為者，由其目的事業主管機關處行為人新臺幣一千元以上五萬元以下罰鍰。(第二項)其攤販、指示標誌或廣告物妨害觀光活動之進行，拆除費用由行為人負擔。
          </div>
        </div>

        <div class="article">
          <div class="article-title-2">第64條：</div>
          <div class="article-content">
          (第一項)於風景特定區或觀光地區內任意露營、焚燒垃圾或棄棄物、將車輛開入禁止車輛進入或禁止停車地區，或有破壞觀光資源或環境衛生之行為，由其目的事業主管機關處行為人新臺幣三千元以上五萬元以下罰鍰，並責令其回復原狀或回復環境。(第二項)損壞、污染或造成環境危害安全之行為，由其目的事業主管機關處新臺幣五千元以上一萬元以下罰鍰。
          </div>
        </div>

            </td>
          </tr>
          </table>
      
            <div class="center note  mt-2">
              本通知單3聯：第1聯 送管理科(白)，第2聯 管理站存(藍)，第3聯 交被通知人(綠)
            </div>
            <div class="note  text-right mr-2">
            ${escapeHTML(item.issueNumber)}
            </div>
          </div>
    `;
  }
);

  htmlContent += `</body></html>`;
  // 建立 iframe 並載入這個 HTML
  // const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.srcdoc = htmlContent;
  document.body.appendChild(iframe);

  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 200);
  };
}